/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_HistoryInputs */

const en_audit_history = /** @type {(inputs: Audit_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit History`)
};

const es_audit_history = /** @type {(inputs: Audit_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de Auditorias`)
};

/**
* | output |
* | --- |
* | "Audit History" |
*
* @param {Audit_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_history = /** @type {((inputs?: Audit_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_history(inputs)
	return es_audit_history(inputs)
});